import axios from 'axios';
import URLS from '../util/urls.js';

const state = {
  caixaAberto: {
    usuario: {}
  },
  caixaAnterior: {},
  historico: [],
  chequesCaixa: [],

  saldo: 0,
  saldoHistorico: 0
}

const mutations = {
  atualizarCaixaAberto(state, payload) {
    state.caixaAberto = payload;

    if(payload){
      state.saldo = 0
      
      state.caixaAberto.lancamentos.forEach((lancamento,index) => {
        if(index === 0) {
          lancamento.saldo = lancamento.valor.toString();
          state.saldo += (parseFloat(lancamento.valor.toString()) * 100);
        } else {
          if(lancamento.operacao == "ENTRADA") {
            state.saldo += (parseFloat(lancamento.valor.toString()) * 100);
            lancamento.saldo = (state.saldo/100).toString();
          } else if(lancamento.operacao == "SAIDA") {
            state.saldo -= (parseFloat(lancamento.valor.toString()) * 100);
            lancamento.saldo = (state.saldo/100).toString();
          }
        }
      });
    }
  },
  atualizarCaixaAnterior(state, payload) {
    state.caixaAnterior = payload;
  },
  atualizarHistorico(state, payload) {
    state.historico = payload;

    state.historico.forEach(caixa => {
      state.saldoHistorico = 0
      caixa.lancamentos.forEach((lancamento,index) => {
        if(index === 0) {
          lancamento.saldo = lancamento.valor.toString();
          state.saldoHistorico += (parseFloat(lancamento.valor.toString()) * 100);
        } else {
          if(lancamento.operacao == "ENTRADA") {
            state.saldoHistorico += (parseFloat(lancamento.valor.toString()) * 100);
            lancamento.saldo = (state.saldoHistorico/100).toString();
          } else if(lancamento.operacao == "SAIDA") {
            state.saldoHistorico -= (parseFloat(lancamento.valor.toString()) * 100);
            lancamento.saldo = (state.saldoHistorico/100).toString();
          }
        }
      });
    });
  },
  atualizarChequesCaixa(state, payload) {
    state.chequesCaixa = payload;
  },
  limparChequesCaixa(state) {
    state.chequesCaixa = [];
  },
}

const actions = {
  abrirCaixa(context, payload) {
    return axios.post(URLS.CAIXAS_ABRIR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCaixaAberto', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('abrirCaixa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  fecharCaixa(context, payload) {
    return axios.post(URLS.CAIXAS_FECHAR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCaixaAberto', undefined);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('fecharCaixa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  gravarLancamento(context, payload) {
    return axios.post(URLS.CAIXAS_GRAVAR_LANCAMENTO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCaixaAberto', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('gravarLancamento', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  removerLancamento(context, payload) {
    return axios.post(URLS.CAIXAS_REMOVER_LANCAMENTO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCaixaAberto', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('removerLancamento', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarCaixaAberto(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_CAIXA_ABERTO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          if(response.data.item){
            context.commit('atualizarCaixaAberto', response.data.item);
          } else {
            context.commit('atualizarCaixaAberto', { usuario: {} });
          }
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarCaixaAberto', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarCaixaAnterior(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_CAIXA_ANTERIOR, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarCaixaAnterior', response.data.item);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarCaixaAnterior', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarHistorico(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_HISTORICO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarHistorico', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarHistorico', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarHistoricoCheque(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_HISTORICO_CHEQUE, { numeroCheque: payload })
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarHistorico', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarHistoricoCheque', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
  recuperarChequesCaixa(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_CHEQUES_NO_CAIXA, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          context.commit('atualizarChequesCaixa', response.data.lista);
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarChequesCaixa', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },

  recuperarSaldo(context, payload) {
    return axios.post(URLS.CAIXAS_RECUPERAR_SALDO, payload)
    .then((response) => {
      switch(response.data.status) {
        case "SUCESSO":
          return response.data;
        case "SESSAO_EXPIRADA":
          return context.dispatch('loginStore/relogar', {}, { root: true })
          .then(authResponse => {
            if(authResponse.status == "SUCESSO") {
              return context.dispatch('recuperarSaldo', payload);
            }
          }).catch((error) => {
            throw error;
          });
        default:
          return response.data;
      }
    }).catch((error) => {
      throw error;
    });
  },
}

export default {
  state,
  mutations,
  actions
}